import {computed} from 'vue'
import {useI18n} from 'vue-i18n'
import {profileFor} from '@/localeProfiles'

// Profil jazykové mutace pro komponenty. Je reaktivní na i18n locale, aby fungoval
// debug přepínač jazyka v App.vue; v sestaveném balíčku se locale nemění, takže je
// hodnota konstantní. Store si profil bere napřímo přes profileFor(), není komponenta.
export function useLocaleProfile() {
    const {locale} = useI18n({useScope: 'global'})
    const profile = computed(() => profileFor(locale.value))
    return {profile}
}
